<template>
  <div class="DoctorFirstPage">
    <div class="head">
      <div class="doctorInfo">
        <div class="face">
          <img :src="touxiang ? touxiang : require('../assets/baseImg.jpg')" alt="" />
        </div>
        <div class="introduce">
          <span class="greet">{{hope}}</span>
          <p class="zhicheng">{{zhicheng}}</p>
        </div>
      </div>
      <div class="demoNum">
        <div class="joinDemo">
          <span class="title">参与案例</span>
          <p class="num">{{Partake}}</p>
        </div>
        <div class="teamCase">
          <span class="title">团队案例</span>
          <p class="num">{{centerNum}}</p>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="conLeft" >
        <Card class="caseOnline" :bordered="false" shadow >
          <p slot="title">
            进行中的案例
          </p>
          <a href="#" slot="extra" @click.prevent="changeLimit">
            全部案例
          </a>
          <Row v-if="caseList.length>0">
            <Col span="8" v-for="(item, index) in caseList" :key="index">
              <Card dis-hover>
                <div class="demo" @click="changeUrl(item.ID)">
                  <div class="demoInfo">
                    <img :src="item.Gender == '男'?require('../assets/boy.png'):require('../assets/girl.png')" />
                    <h3 class="demoName"><!-- {{item.ID}}  -->{{item.PatientName}} {{item.Gender}} {{item.Age}}岁</h3>
                  </div>
                  <div class="illness">{{item.Complaint}}</div>
                  <div class="demoDoctor">
                    <span>{{item.DocName}}医生</span><span>{{changeTime(item.UpdDate)}}</span>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
          <div class="noCase" v-else>暂无进行中的案例</div>
        </Card>
        <List class="trends" header="动态" border>
          <ListItem v-for="(item, index) in Trends" :key="index">
            <div class="doctorInfo" @click="gotoUrl(item)">
              <div class="face">
                <img :src="item.Img?item.Img:require('../assets/doctor.png')" alt="" />
              </div>
              <div class="introduce">
                <span class="greet" v-html="item.Dynamic"></span
                >
                <p class="time">{{changeTime(item.Date)}}</p>
              </div>
            </div>
          </ListItem>
        </List>
      </div>
      <div class="conRight">
        <Card class="demoNumCard" :bordered="false" shadow>
          <p slot="title">案例数量</p>
          <div class="circlebox">
            <div class="circle">
              <div class="imgBox">
                <img src="../assets/u416.png" alt="" @click="()=>{this.$router.push('CaseDiscussion/tab_1')}">
              </div>
              <p @click="()=>{this.$router.push('CaseDiscussion/tab_1')}">进行中<span>{{this.caseNum.lCount}}</span></p>
            </div>
            <div class="circle">
              <div class="imgBox">
                <img src="../assets/u420.png" alt="" @click="()=>{this.$router.push('CaseDiscussion/tab_2')}">
              </div>
              <p @click="()=>{this.$router.push('CaseDiscussion/tab_2')}">已结束<span>{{this.caseNum.mCount}}</span></p>
            </div>
            <div class="circle">
              <div class="imgBox">
                <img src="../assets/u418.png" alt="" @click="()=>{this.$router.push('CaseDiscussion/tab_3')}">
              </div>
              <p @click="()=>{this.$router.push('CaseDiscussion/tab_3')}">随访中<span>{{this.caseNum.rCount}}</span></p>
            </div>
          </div>
        </Card>
        <Card class="operation" :bordered="false" shadow>
          <p slot="title">手术情况</p>
          <Table :columns="columns1" :data="data1">
            <template slot-scope="{ row, index }" slot="jindutiao">
            <Progress :percent="row.sum" status="active">
              <span>{{ row.sum }}</span>
            </Progress>
          </template>
          </Table>
          
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { Card, Col, Row, List, Circle, Table ,Progress} from "view-design";
import Request from "../utils/request";
import config from "../config";
import dayjs from "dayjs";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Card,
    Col,
    Row,
    List,
    ListItem: List.Item,
    MyCricle: Circle,
    Table,
    Progress,
  },
  data() {
    // 这里存放数据
    return {
      columns1: [
        {
          title: "排名",
          key: "rank",
        },
        {
          title: "手术名称",
          key: "name",
        },
        {
          title: "数量",
          slot: "jindutiao",
        },
        {
          title: "占比",
          key: "percent",
        },
      ],
      data1: [
        // {
        //   rank: 1,
        //   name: "阑尾切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 2,
        //   name: "胆囊切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 3,
        //   name: "胃切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 4,
        //   name: "胃十二指肠吻合术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 5,
        //   name: "痔切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 1,
        //   name: "阑尾切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 2,
        //   name: "胆囊切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 3,
        //   name: "胃切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 4,
        //   name: "胃十二指肠吻合术",
        //   sum: 18,
        //   percent: "20%",
        // },
        // {
        //   rank: 5,
        //   name: "痔切除术",
        //   sum: 18,
        //   percent: "20%",
        // },
      ],
      Partake:0,//参与案例
      centerNum:0,//团队案例
      caseList:[],//进行中的案例
      caseNum:{},//案例数量
      Trends:[],//动态
      hope:'',//祝福
      zhicheng:'',//职称
      touxiang:JSON.parse(localStorage.getItem('Role')).ImgUrl
    };
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$emit("funChangeTitle", "首页", "1");
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.GetCaseNumbyDoc()
    this.GetInProgressCaseList()
    this.GetCaseStatusCount()
    this.GetTrendsList()
    this.getNow()
    this.GetOperationList()
  },
  // 这里存放数据
  beforeCreate() {},
  // 生命周期 - 挂载之前
  beforeMount() {},
  // 生命周期 - 更新之前
  beforeUpdate() {},
  // 生命周期 - 更新之后
  updated() {},
  // 生命周期 - 销毁之前
  beforeDestroy() {},
  // 生命周期 - 销毁完成
  destroyed() {},
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
  // 方法集合
  methods: {
    //跳转url
    gotoUrl(info){
      console.log(info)
      if(info.PageNum){
        this.$router.push(`CaseDetail/${info.CaseID}/${info.PageNum}`)
      }else{
        this.$router.push(`CaseDetail/${info.CaseID}/1`)
      }
    },
    //获取手术情况
    GetOperationList(){
      let roleid = JSON.parse(localStorage.getItem('Role')).RoleID
      let obj = {}
      if(roleid == 2){
        obj.CenterID = JSON.parse(localStorage.getItem('Role')).CenterID
      }else if(roleid == 1){
        obj.UserJid = JSON.parse(localStorage.getItem('Role')).UserJid
      }
      Request.getRequest(config.WJ_baseUrl+'/api/docmanager/GetOperationList',obj).then(res=>{
        /* 
         [ {
          rank: 1,
          name: "阑尾切除术",
          sum: 18,
          percent: "20%",
        },
        {
          rank: 2,
          name: "胆囊切除术",
          sum: 18,
          percent: "20%",
        },]
        */
       let arr = [];
        res.data.map((item,index)=>{
          arr.push({rank:index+1,name:item.SurgicalName,sum:item.Count,percent:(item.Ratio*100).toFixed(2)+'%'})
        })
        this.data1 = arr
      })
    },
    //跳转到指定的页面
    changeUrl(id){
      this.$router.push(`CaseDetail/${id}/1`)
    },
    //跳转到进行中的案例
    changeLimit(){
      this.$router.push('CaseDiscussion/tab_1')
    },
    //获取案例数量
    GetCaseStatusCount(){
      let roleid = JSON.parse(localStorage.getItem('Role')).RoleID
      let obj = {}
      if(roleid == 2){
        obj.CenterID = JSON.parse(localStorage.getItem('Role')).CenterID
      }else if(roleid == 1){
        obj.UserJid = JSON.parse(localStorage.getItem('Role')).UserJid
      }
      Request.getRequest(config.WJ_baseUrl+'/api/docmanager/GetCaseStatusCount',obj).then(res=>{
        if(res.code == 200){
          this.caseNum = res.data[0]
        }
      })
    },

    //获取参与案例和团队案例
    GetCaseNumbyDoc(){
      let roleid = JSON.parse(localStorage.getItem('Role')).RoleID
      let obj = {
        UserJid:JSON.parse(localStorage.getItem('Role')).UserJid,
        CenterID:JSON.parse(localStorage.getItem('Role')).CenterID
      }
      // if(roleid == 2){
      //   obj.CenterID = JSON.parse(localStorage.getItem('Role')).CenterID
      // }else if(roleid == 1){
      //   obj.UserJid = JSON.parse(localStorage.getItem('Role')).UserJid
      // }
      Request.getRequest(config.SXG_baseUrl+'/api/docmanager/GetCaseNumbyDoc',obj).then(res=>{
        if(res.code == 200){
          this.Partake = res.data.Partake;
          this.centerNum = res.data.centerNum
        }
      })
    },
    //获取进行中的案例
    GetInProgressCaseList(){
      let roleid = JSON.parse(localStorage.getItem('Role')).RoleID
      let obj = {}
      if(roleid == 2){
        obj.CenterID = JSON.parse(localStorage.getItem('Role')).CenterID
      }else if(roleid == 1){
        obj.UserJid = JSON.parse(localStorage.getItem('Role')).UserJid
      }
      Request.getRequest(config.WJ_baseUrl+'/api/docmanager/GetInProgressCaseList',obj).then(res=>{
        if(res.code == 200){
          this.caseList = res.data
        }
      })
    },
    //获取动态
    GetTrendsList(){
      let roleid = JSON.parse(localStorage.getItem('Role')).RoleID
      let obj = {}
      if(roleid == 2){
        obj.CenterID = JSON.parse(localStorage.getItem('Role')).CenterID
      }else if(roleid == 1){
        obj.UserJid = JSON.parse(localStorage.getItem('Role')).UserJid
      }
      Request.getRequest(config.WJ_baseUrl+'/api/docmanager/GetTrendsList',obj).then(res=>{
        if(res.code == 200){
          this.Trends = res.data
          this.$forceUpdate()
        }
      })
    },
    //转换时间戳
    changeTime(oldTime){
      let timeDiff = dayjs().diff(dayjs(oldTime),'minute')
      if(timeDiff == 0){
        return '1分钟前'
      }else if(timeDiff >0&&timeDiff<60){
        return timeDiff + '分钟前'
      }else if(timeDiff >=60&&timeDiff<1440){
        var hour = Math.round(timeDiff/60)
        return hour + '小时前'
      }else if(timeDiff >=1440&&timeDiff<2880){
        // return dayjs(oldTime).format('YYYY-MM-DD  HH:mm:ss')
        return '一天前'
      }else if(timeDiff >=2880){
        return dayjs(oldTime).format('YYYY-MM-DD  HH:mm:ss')
      }
    },
    //获取当前时间
    getNow(){
      if(dayjs().hour()>0&&dayjs().hour()<12){
        this.hope = '上午好，'+JSON.parse(localStorage.getItem('Role')).DocName + '，祝你开心每一天'
      }else if(dayjs().hour()>=12&&dayjs().hour()<14){
        this.hope = '中午好，'+JSON.parse(localStorage.getItem('Role')).DocName + '，祝你开心每一天'
      }else if(dayjs().hour()>=14&&dayjs().hour()<24){
        this.hope = '下午好，'+JSON.parse(localStorage.getItem('Role')).DocName + '，祝你开心每一天'
      }
      if(JSON.parse(localStorage.getItem("Role")).ImgUrl){
        this.zhicheng = JSON.parse(localStorage.getItem('Role')).DocPosition+' | '+JSON.parse(localStorage.getItem('Role')).DepartmentName
      }else{
        this.zhicheng = JSON.parse(localStorage.getItem('Role')).DepartmentName
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
};
</script>

<style lang="less">
/* @import url(); 引入公共css类 */
.DoctorFirstPage {
  height: 100%;
  width: 100%;
  background: rgb(240, 242, 245);
  box-sizing: border-box;
  .head {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 40px;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .doctorInfo {
      height: 120px;
      width: 70%;
      // background: red;
      display: flex;
      align-items: center;
      .face {
        width: 80px;
        height: 80px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 40px;
          box-shadow: 0px 0px 1px #666;
        }
      }
      .introduce {
        width: 800px;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 40px;
        .greet {
          font-size: 18px;
          color: black;
          
        }
        .zhicheng {
          margin-top: 10px;
          font-size: 13px;
          color: rgb(151, 144, 144);
        }
      }
    }
    .demoNum {
      height: 60px;
      width: 30%;
      display: flex;
      padding-right: 100px;
      .title {
        font-family: "MicrosoftYaHei", "Microsoft YaHei";
        font-weight: 400;
        font-style: normal;
        color: rgba(0, 0, 0, 0.427450980392157);
        line-height: 22px;
      }
      .num {
        font-size: 30px;
        color: rgba(0, 0, 0, 0.847058823529412);
        line-height: 38px;
      }
      .joinDemo {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .teamCase {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left: 1px solid rgba(0, 0, 0, 0.3);
      }
    }
  }
  .content {
    width: 100%;
    margin-top: 15px;
    background: rgb(240, 242, 245);
    display: flex;
    min-height: calc(100% - 156px);
    .conLeft {
      width: 60%;
      background: rgb(240, 242, 245);
      .caseOnline {
        width: 100%;
        .ivu-card-body {
          padding: 0;
          .ivu-card {
            border-radius: 0;
            border-left: none;
            border-top: none;
          }
          .demo {
            cursor: pointer;
            transition-duration: 0.5s;
            transition-timing-function: ease;
            transition-property:all ;
            .demoInfo {
              width: 100%;
              display: flex;
              align-items: center;
              padding: 30px 30px 15px 30px;
              img {
                display: block;
                width: 30px;
                height: 30px;
                border-radius: 15px;
                box-shadow: 0px 0px 1px #666;
              }
              .demoName {
                margin-left: 20px;
                color: black;
                overflow:hidden; //超出部分隐藏
                white-space:nowrap;//不换行
                text-overflow:ellipsis; //超出部分用...代替
              }
            }
            .illness {
              margin-left: 80px;
              height: 18px;
              font-size: 12px;
              color: rgb(187, 172, 172);
              overflow:hidden; //超出部分隐藏
              white-space:nowrap;//不换行
              text-overflow:ellipsis; //超出部分用...代替
            }
            .demoDoctor {
              padding: 20px;
              display: flex;
              justify-content: space-between;
              font-size: 12px;
              color: rgb(187, 172, 172);
            }
          }
          .demo:hover{
            background: rgb(238, 236, 236);
          }
          .noCase{
            padding: 10px;
            text-align: center;
          }
        }
      }
      .trends {
        margin-top: 15px;
        background: white;
        
        overflow-y: auto;
        
        .ivu-list-item{
          cursor: pointer;
          transition-duration: 0.5s;
          transition-timing-function: ease;
          transition-property:all ;
        }
        
        .ivu-list-item:hover{
          background: rgb(238, 236, 236);
        }
        .ivu-list-header {
          font-family: "Microsoft Tai Le Bold", "Microsoft Tai Le";
          font-weight: 700;
          font-style: normal;
          font-size: 16px;
          text-align: left;
          line-height: 24px;
        }
        .doctorInfo {
          height: 60px;
          // background: red;
          display: flex;
          align-items: center;
          .face {
            width: 40px;
            height: 40px;
            
            img {
              display: block;
              width: 100%;
              height: 100%;
              border-radius: 20px;
              box-shadow: 0px 0px 1px #666;
            }
          }
          .introduce {
            width: 800px;
            height: 60px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 40px;
            .greet {
              font-size: 15px;
              font-weight: bold;
              span{
                font-weight: 800;
                color: black;
                padding: 0 5px;
              }
              em {
                font-style: normal;
                color: rgb(25, 111, 223);
                padding: 0 5px;
              }
            }
            .time {
              margin-top: 3px;
              font-size: 13px;
              color: rgb(151, 144, 144);
            }
          }
        }
        .ivu-list-container{
          height: 415px;
          overflow-y: auto;
        }
      }
    }
    .conRight {
      width: 40%;
      margin-left: 15px;
      background: rgb(240, 242, 245);
      .demoNumCard {
        .circlebox {
          width: 100%;
          display: flex;
          .circle {
            width: 33%;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            .imgBox{
              width: 100px;
              height: 100px;
              img{
                cursor: pointer;
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            p {
              cursor: pointer;
              margin-top: 20px;
              margin-block: 20px;
              font-size: 14px;
              span{
                margin-left: 5px;
                font-size: 18px;
                color: #1890FF;
                font-weight: bold;
              }
            }
          }
        }
      }
      .operation {
        margin-top: 15px;
        background: white;
        .ivu-card-head {
          p {
            font-family: "Microsoft Tai Le Bold", "Microsoft Tai Le";
            font-weight: 700;
            font-style: normal;
            font-size: 16px;
            text-align: left;
            line-height: 24px;
          }
        }
        .ivu-card-body {
          height: 371px;
          overflow-y: auto;
          padding: 0;
          .ivu-table th {
            background: white;
          }
        }
      }
    }
  }
}
</style>
